import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { StatusChangeDialogValues } from "./StatusChangeDialogWrapper";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";

type Props = {
  formikProps: FormikProps<StatusChangeDialogValues>;
  onClose: () => void;
};

const StatusChangeDialog = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting } = formikProps;
  return (
    <div className="flex flex-col gap-6 p-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-medium">Approve Request</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMDatePicker
            format="DD/MM/YYYY"
            // minDate={new Date()}
            required
            name="accessStartDate"
            value={values?.accessStartDate || null}
            onChange={(newValue) => setFieldValue("accessStartDate", newValue)}
            label="Access Start Date"
          />
        </div>
        <div>
          <ATMDatePicker
            format="DD/MM/YYYY"
            required
            name="accessEndDate"
            value={values?.accessEndDate || null}
            onChange={(newValue) => setFieldValue("accessEndDate", newValue)}
            label="Access End Date"
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StatusChangeDialog;
